<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productCard"
  >
    <form
      autocomplete="off"
      class="m-edition-product-card"
      name="update-producto-form"
      @submit.prevent="updateProducto"
    >
      <div class="m-edition-product-card-content">
        <!-- estados, categoría y descripción del producto -->
        <div class="m-edition-product-card-data">
          <h3
            v-if="cardType === 3"
            class="margin-top-zero"
          >
            {{ $t('mEditionProductCard.inputs.video.label') }}
          </h3>
          <p
            v-if="cardType === 3"
            class="margin-top-zero"
          >
            <AtomInputPrimary
              v-model="videoUrl"
              :inputError="$v.videoUrl.$error"
              :message="$t('mEditionProductCard.inputs.video.message')"
              :messageError="messageErrorVideo"
              name="video"
              reference="video"
              type="text"
              wrapper-class="a-input-wrapper-column margin-bottom-zero margin-top-zero"
              @blur="$v.videoUrl.$touch()"
            />
          </p>

          <h3 :class="cardType === 3 ? 'margin-top-xxlarge' : 'margin-top-zero'">
            {{ $t('mEditionProductCard.inputs.descripcion.label') }}
          </h3>
          <p class="margin-top-zero">
            <AtomTextAreaPrimary
              v-model="producto.descripcion.descripcion"
              :inputError="$v.producto.descripcion.descripcion.$error"
              :message="$t('mEditionProductCard.inputs.descripcion.message')"
              :messageError="messageErrorDescripcion"
              name="descripcion"
              reference="descripcion"
              rows="3"
              wrapper-class="a-input-wrapper-column margin-bottom-zero margin-top-zero"
              @blur="$v.producto.descripcion.descripcion.$touch()"
            />
          </p>

          <h3 class="margin-top-xxlarge">
            {{ $t('mEditionProductCard.inputs.etiquetas.label') }}
          </h3>
          <p class="margin-top-zero">
            <multiselect
              v-model="producto.descripcion.etiquetas"
              :multiple="true"
              :options="options"
              :placeholder="$t('mEditionProductCard.inputs.etiquetas.placeholder')"
              ref="etiquetas"
              :taggable="true"
              @tag="addTag"
            >
            </multiselect>
          </p>

          <h3 class="margin-top-xxlarge">
            {{ $t('mEditionProductCard.inputs.categoria.label') }}
          </h3>
          <p class="margin-top-zero">
            <AtomSelectPrimary
              v-model.number="producto.descripcion.categoria"
              :elements="elementCategorias"
              :inputError="$v.producto.descripcion.categoria.$error"
              :messageError="messageErrorCategoria"
              key-field="id_producto_categoria"
              name="categoria"
              reference="categoria"
              text-field="nombre"
              wrapper-class="a-input-wrapper-column margin-bottom-xsmall margin-top-zero"
              @blur="$v.producto.descripcion.categoria.$touch()"
            />
          </p>

          <p class="margin-top-xxlarge">
            <AtomButtonPrimary
              class="margin-right-small"
              :button-primary="buttonPrimary"
            />
            <AtomButtonSecondary
              :button-secondary="buttonSecondary.reset"
              @resetEditor="resetEditor"/>
          </p>
        </div>

        <!-- tarjeta seleccionada por el usuario -->
        <div class="m-edition-product-card-design">
          <MoleculeFeedSectionContentCard
            :is="moleculeCardEditionDesign"
            :element="producto"
            :es-pago="productoInicial.pago"
            :element-categorias="elementCategorias"
            :show-metadata-validation-error="showMetadataValidationError"
            :video-url-parsed="videoUrlParsed"
            @changeCardType="changeCardType"
            @changeElementCard="changeElementCard"
            @changeElementNombre="changeElementNombre"
            @getValidationError="getValidationError"
            @getReference="getReference"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
import { validateVideoUrl } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionProductCard',

  components: {
    Multiselect: () => import('vue-multiselect')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductCard.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: 'far fa-times',
          method: 'resetEditor',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'button'
        }
      },

      moleculeCardEditionDesign: () => import(`@/components/molecules/MoleculeFeedSectionContentCardEditionDesign${this.cardType}`),
      options: [],

      producto: {
        descripcion: {
          categoria: 0,
          descripcion: '',
          etiquetas: [],
          nombre: ''
        },

        estado: {
          activo: false,
          visible: false
        },

        tarjeta: {}
      },

      primeraVez: true,
      productoInicial: {},
      productoReset: {},

      showMetadataValidationError: false,
      showLoadingState: true,

      tarjetaDefault: {
        tipo: 2,
        metadata: {
          imagen: ''
        }
      },

      validationError: {
        card: false,
        name: false
      },

      videoThumbnail: '',
      videoUrl: '',
      videoUrlParsed: ''
    }
  },

  validations: {
    producto: {
      descripcion: {
        descripcion: {
          maxLength: maxLength(120),
          minLength: minLength(10),
          required
        },
        categoria: {
          required
        }
      }
    },

    videoUrl: {
      required: requiredIf(function () {
        return this.cardType === 3
      }),
      validUrl: validateVideoUrl
    }
  },

  computed: {
    cardType () {
      return this.$store.getters.getCardType !== null
        ? this.$store.getters.getCardType
        : this.producto.tarjeta.tipo
    },

    messageErrorDescripcion () {
      return this.$validation.getValidationMessage('mEditionProductCard', this.$v.producto.descripcion.descripcion, 'descripcion')
    },

    messageErrorCategoria () {
      return this.$validation.getValidationMessage('mEditionProductCard', this.$v.producto.descripcion.categoria, 'categoria')
    },

    messageErrorVideo () {
      return this.$validation.getValidationMessage('mEditionProductCard', this.$v.videoUrl, 'video')
    }
  },

  watch: {
    element () {
      this.setProducto()
      this.$store.commit('setCardType', this.element.tarjeta ? this.element.tarjeta : 2)
    },

    'producto': {
      deep: true,
      handler (newValue, oldValue) {
        if (!this.primeraVez && JSON.stringify(newValue) !== JSON.stringify(this.productoReset)) {
          this.$store.commit('setExitEdition', true)
        }
      }
    },

    videoUrl () {
      this.videoUrlParsed = this.$utils.parseVideo(this.videoUrl, true)
      let thumbnailSrc = ''

      this.$services.read('producto', 'readProductoMiniaturaVideo', {}, [], { url: this.videoUrl })
        .then(response => {
          thumbnailSrc = response.data
        })
        .catch(error => console.log(error))
        .then(() => {
          this.videoThumbnail = thumbnailSrc
          this.producto.tarjeta = {
            tipo: 3,
            metadata: {
              url_thumbnail: thumbnailSrc,
              url_video: this.videoUrl
            }
          }
        })
    },

    '$store.getters.getExitEditionRoute' () {
      if (this.$store.getters.getExitEditionRoute.edition && !this.primeraVez) {
        this.$modal.showModal('MoleculeEditionExitModal', '')
      }
    }
  },

  created () {
    this.productoInicial = this.$store.getters.getCardData
    if ((JSON.stringify(this.productoInicial) !== JSON.stringify(this.element)) && (!(this.productoInicial.id !== undefined && this.productoInicial.id === this.element.id))) {
      this.productoInicial = this.element
      this.$store.commit('setCardData', this.productoInicial)
    }
    this.setProducto()
    this.productoReset = JSON.parse(JSON.stringify(this.producto))
    setTimeout(() => {
      this.primeraVez = false
    }, 1000)
  },

  destroyed () {
    this.$store.commit('setCardType', null)
  },

  methods: {
    addTag (tag) {
      this.$refs.etiquetas.$el.focus()
      this.producto.descripcion.etiquetas.push(tag)
    },

    changeCardType (cardType) {
      this.setProductoInicial()
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$route.params.subject}/${cardType}/${this.$t('mEditionMenu.product.card.children.types.subedition')}`)
    },

    changeElementCard (card) {
      this.producto.tarjeta = Object.assign({}, card)
    },

    changeElementNombre (nombre) {
      this.producto.descripcion.nombre = nombre
    },

    getReference (name, ref) {
      this.$refs[name] = ref
    },

    getValidationError (vKey, vError) {
      this.validationError[vKey] = vError
    },

    resetEditor () {
      this.setProducto()
    },

    setProducto () {
      this.producto = {
        descripcion: {
          categoria: this.productoInicial.categoria ? this.productoInicial.categoria.id_producto_categoria : 1,
          descripcion: this.productoInicial.descripcion,
          etiquetas: this.productoInicial.etiquetas !== undefined ? [...this.productoInicial.etiquetas] : [],
          nombre: this.productoInicial.nombre
        },

        estado: {
          activo: +this.productoInicial.activo,
          visible: +this.productoInicial.visible
        },

        tarjeta: this.productoInicial.metadata
          ? Object.assign({}, { tipo: this.productoInicial.tarjeta, metadata: Object.assign({}, this.productoInicial.metadata) })
          : Object.assign({}, this.tarjetaDefault)
      }

      if (this.productoInicial.tarjeta === 3 && this.productoInicial.metadata) {
        this.videoThumbnail = this.productoInicial.metadata.url_thumbnail
        this.videoUrl = this.productoInicial.metadata.url_video
        this.videoUrlParsed = this.$utils.parseVideo(this.productoInicial.metadata.url_video, true)
      }

      this.showLoadingState = false
      this.$store.commit('setExitEdition', false)
    },

    setProductoInicial () {
      this.productoInicial.descripcion = this.producto.descripcion.descripcion
      this.productoInicial.etiquetas = this.producto.descripcion.etiquetas
      this.productoInicial.nombre = this.producto.descripcion.nombre
      if (this.productoInicial.categoria === undefined) {
        this.productoInicial.categoria = {}
        this.productoInicial.categoria.id_producto_categoria = this.producto.descripcion.categoria
      } else {
        this.productoInicial.categoria.id_producto_categoria = this.producto.descripcion.categoria
      }
      if (this.productoInicial.metadata === undefined) {
        this.productoInicial.metadata = {}
        this.productoInicial.metadata = this.producto.tarjeta.metadata
      } else {
        this.productoInicial.metadata = this.producto.tarjeta.metadata
      }
      this.productoInicial.tarjeta = this.producto.tarjeta.tipo
      this.$store.commit('setCardData', this.productoInicial)
    },

    updateProducto () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      this.showMetadataValidationError = true
      if (Object.values(this.validationError).find(verror => verror) === undefined &&
        !this.buttonPrimary.sending &&
        !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.update('producto', 'updateProducto', { producto: this.producto }, [this.$route.params.id])
          .then(response => {
            this.$modal.updateData('readElement')
            this.$alerts.pushAlert('mEditionProductCard', 'updateProducto', 'success')
            this.buttonPrimary.sending = false
            this.showMetadataValidationError = false
            this.setProductoInicial()
            this.$store.commit('setExitEdition', false)
            this.$store.commit('setCardType', null)
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductCard', 'updateProducto', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
            this.showMetadataValidationError = false
          })
      } else {
        this.$nextTick(() => {
          switch (true) {
            case this.validationError.name === true:
              this.$refs.nombre.focus()
              break
            case this.validationError.card === true:
              let bandera = true
              if (bandera && this.$refs.texto1 !== undefined && this.$refs.texto1[0].value === '') {
                this.$refs.texto1[0].focus()
                bandera = false
              }
              if (bandera && this.$refs.texto2 !== undefined && this.$refs.texto2[0].value === '') {
                this.$refs.texto2[0].focus()
                bandera = false
              }
              if (bandera && this.$refs.texto3 !== undefined && this.$refs.texto3[0].value === '') {
                this.$refs.texto3[0].focus()
                bandera = false
              }
              if (bandera && this.$refs.imagen !== undefined) {
                this.$refs.imagen.scrollIntoView()
                bandera = false
              }
              if (bandera && this.$refs.imagen1 !== undefined && this.$refs.imagen1[0].className === 'm-card-element-edition-image-error') {
                this.$refs.imagen1[0].scrollIntoView()
                bandera = false
              }
              if (bandera && this.$refs.imagen2 !== undefined && this.$refs.imagen2[0].className === 'm-card-element-edition-image-error') {
                this.$refs.imagen2[0].scrollIntoView()
                bandera = false
              }
              if (bandera && this.$refs.imagen3 !== undefined && this.$refs.imagen3[0].className === 'm-card-element-edition-image-error') {
                this.$refs.imagen3[0].scrollIntoView()
                bandera = false
              }
              if (bandera && this.$refs.imagen4 !== undefined && this.$refs.imagen4[0].className === 'm-card-element-edition-image-error') {
                this.$refs.imagen4[0].scrollIntoView()
                bandera = false
              }
              break
          }
        })
      }
    },

    updateThumbnail () {
      let src = '@/assets/img/ds3.png'
      this.$services.read('producto', 'readProductoMiniaturaVideo', {}, [], { url: this.videoUrl })
        .then(response => {
          src = response.data
        })
        .catch(error => {
          console.log(error)
          src = ''
        })
        .then(() => {
          return src
        })
    }
  }
}
</script>
